var React = require('react');

function Iam (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"AWS-Identity-and-Access-Management-IAM_Add-on_dark-bg"),React.createElement("path",{"d":"M13.51,37A12,12,0,1,1,24.7,20.65H27l2.58-2.58a1,1,0,0,1,1.41,0l2.58,2.58h1.09l2.58-2.58a1,1,0,0,1,.71-.29h0a1,1,0,0,1,.7.29l2.58,2.58h2.46a1,1,0,0,1,.66.25l3.83,3.35a1,1,0,0,1,.1,1.4L45.39,29a1,1,0,0,1-.76.35H24.7A11.94,11.94,0,0,1,13.51,37Zm0-22A10,10,0,1,0,23,28.05a1,1,0,0,1,1-.7H44.17L46.1,25.1l-2.81-2.45H40.8a1,1,0,0,1-.71-.29l-2.16-2.17-2.17,2.17a1,1,0,0,1-.71.29H33.14a1,1,0,0,1-.71-.29l-2.16-2.17L28.1,22.36a1,1,0,0,1-.71.29H24a1,1,0,0,1-1-.7A10,10,0,0,0,13.51,15ZM10.16,29.35A4.35,4.35,0,1,1,14.51,25,4.35,4.35,0,0,1,10.16,29.35Zm0-6.7A2.35,2.35,0,1,0,12.51,25,2.35,2.35,0,0,0,10.16,22.65Z","key":1})]);
}

Iam.defaultProps = {"viewBox":"0 0 50 50"};

module.exports = Iam;

Iam.default = Iam;
